import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import cookie from 'react-cookies';
import { originURLMapping } from '../../../shortcut/shortcutUtils';

class PageDetail extends Component {
  render() {
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    const { version, currentPageId, page, projectId } = this.props;
    const { name, uuid } = page;
    const redirectUrl = `${originURLMapping('Page')}`;
    return (
      <Fragment>
        <a
          href={`${redirectUrl}/editor/${version}/v/${projectId}/pages/${uuid}?token=${token}`}
          onClick={() => {
            this.props.togglePageModal();
            Mixpanel.track(`Opens page on builder`, { name, uuid });
          }}
          className={`list-group-item list-group-item-action align-items-center ${
            currentPageId === uuid ? 'active' : ''
          }`}
          style={{ cursor: 'pointer', width: '90%', float: 'left' }}
        >
          <i className="gjs-caret-icon fa fa-file-text-o"></i>&nbsp; {name}
        </a>
        <a
          className="pages-list-left-menu"
          onClick={() => {
            this.props.toggleCreatePage(this.props.page);
            this.props.togglePageModal();
            Mixpanel.track(`Clicked on page detail open icon on builder`, { name, uuid });
          }}
        >
          <span
            className="badge badge-theme"
            style={{ padding: 8, cursor: 'pointer', float: 'right' }}
          >
            <i className="gjs-caret-icon fa fa-cog" size={'md'}></i>
          </span>
        </a>
      </Fragment>
    );
  }
}

PageDetail.propTypes = {
  page: PropTypes.object.isRequired,
};

export default PageDetail;
